/* eslint-disable no-underscore-dangle */
import {
  Tracker,
  UserFactory,
  Searcher,
  Recommender,
} from '@relewise/client';
import { v4 as uuidV4 } from 'uuid';
import Cookies from 'js-cookie';

class Middleman {
  constructor() {
    const { datasetId, apiKey } = window.theme.relewise;

    this.isEnabled = false;
    this.init = this.init.bind(this);

    if (datasetId !== '' && apiKey !== '') {
      this.datasetId = datasetId;
      this.apiKey = apiKey;

      this.init();
    }
  }

  setSettings() {
    this.settings = {
      language: window.Shopify.shop === 'aveny-dk.myshopify.com' ? 'av-dk' : window.Shopify.locale,
      currency: window.Shopify.shop === 'aveny-dk.myshopify.com' ? 'AVENY-DK-DKK' : window.Shopify.currency.active,
      user: {
        ...this.getUser(),
        ...{
          classifications: {
            Country: window.location.host.split('.')[1].toUpperCase(),
          },
        },
      },
    };
  }

  init() {
    this.isEnabled = true;

    this.tracker = new Tracker(this.datasetId, this.apiKey);
    this.searcher = new Searcher(this.datasetId, this.apiKey);
    this.recommender = new Recommender(this.datasetId, this.apiKey);

    if (!localStorage.getItem('userId')) {
      localStorage.setItem('userId', uuidV4());
    }

    const updateUser = async () => {
      this.setUser();
      this.setSettings();
    };

    window.addEventListener('CookieInformationConsentGiven', updateUser);
    window.addEventListener('CookieScriptAccept', updateUser);
    window.addEventListener('CookieScriptAcceptAll', updateUser);
    window.addEventListener('CookieScriptReject', updateUser);

    this.setSettings();
  }

  isAnonymous() {
    return !Object.prototype.hasOwnProperty.call(this.settings.user, 'temporaryId');
  }

  getUser() {
    let ciConsent = window?.CookieInformation?.getConsentGivenFor('cookie_cat_marketing') || false;
    let ciUserId = window?.CookieInformation?._getVisitorId();
    if (Cookies.get('CookieInformationConsent')) {
      const ci = JSON.parse(decodeURIComponent(Cookies.get('CookieInformationConsent')));
      ciConsent = ci.consents_approved.includes('cookie_cat_marketing');
      if (ci.user_uid) ciUserId = ci.user_uid;
    }

    if (ciConsent) {
      const id = ciUserId || localStorage.getItem('userId');
      return UserFactory.byTemporaryId(id);
    }

    const cookieScriptConsent = window.CookieScript && window.CookieScript.instance ? window.CookieScript.instance.currentState() : Cookies.get('CookieScriptConsent') && JSON.parse(Cookies.get('CookieScriptConsent'));
    if (cookieScriptConsent && localStorage.getItem('userId')) {
      return UserFactory.byTemporaryId(localStorage.getItem('userId'));
    }

    return UserFactory.anonymous();
  }

  setUser() {
    const cookieScriptConsent = window.CookieScript && window.CookieScript.instance ? window.CookieScript.instance.currentState() : Cookies.get('CookieScriptConsent') && JSON.parse(Cookies.get('CookieScriptConsent'));
    let ciConsent = window?.CookieInformation?.getConsentGivenFor('cookie_cat_marketing') || false;
    let ciUserId = window?.CookieInformation?._getVisitorId();
    if (Cookies.get('CookieInformationConsent')) {
      const ci = JSON.parse(decodeURIComponent(Cookies.get('CookieInformationConsent')));
      ciConsent = ci.consents_approved.includes('cookie_cat_marketing');
      if (ci.user_uid) ciUserId = ci.user_uid;
    }

    if (ciConsent) {
      localStorage.setItem('userId', ciUserId);
      this.user = UserFactory.byTemporaryId(localStorage.getItem('userId'));
    } else if (cookieScriptConsent && localStorage.getItem('userId')) {
      this.user = UserFactory.byTemporaryId(localStorage.getItem('userId'));
    } else {
      this.user = UserFactory.anonymous();
    }
  }

  userkey() {

  }
}

export default Middleman;
